import $ from 'jquery';

$( document ).ready(function() {
	$('#lc-svg').find('.lc-section-group').hover(
		function() {
			if(this.id === 'top-left') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '4' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
				});
			} else if(this.id === 'top-right') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '1' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
				});
			} else if(this.id === 'bottom-left') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '3' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
				});
			} else if(this.id === 'bottom-right') {
				$('.content').each(function(){
					if($(this).attr('data-section') === '2' ) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
				});
			}
		}
	);

	$('#lc-svg').find('.lc-section-group').mouseenter(function(e){
		const currentRotVal = parseInt($('#aws_rot_val').val());
		const arrows = document.querySelector('#path953');
		const computedStyles = window.getComputedStyle(arrows);
		const computedRotateMatrix = computedStyles.getPropertyValue("-webkit-transform") ||
			computedStyles.getPropertyValue("-moz-transform") ||
			computedStyles.getPropertyValue("-ms-transform") ||
			computedStyles.getPropertyValue("-o-transform") ||
			computedStyles.getPropertyValue("transform") ||
			"fail...";

		document.getElementById("path953").style.transform = "rotate("+currentRotVal+"deg)";
		$('#aws_rot_val').val(currentRotVal + 180);
	});
});
